<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.users" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a routerLink="/users">Users</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Groups</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button *ngIf="canAdd" type="button" class="btn btn-outline-primary me-2" routerLink="new">
				<fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
				<span class="cp-action-button-text">New Group</span>
			</button>

			<button type="button" class="btn btn-outline-secondary" (click)="loadData(true)">
				<fa-icon icon="sync-alt" size="sm" [spin]="refreshing" ngbTooltip="Refresh" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<div *ngIf="loading || refreshing" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>

		</thead>

		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow" [ngClass]="{'text-danger': item.is_enabled === 0}">
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
						ngbTooltip="Enabled - Users inherit access" placement="end"></fa-icon>
					<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
						ngbTooltip="Disabled - Users do not inherit access" placement="end"></fa-icon>
				</td>
				<td class="cp-chopped-col-long"><a [routerLink]="[item.id]">{{ item.name }}</a></td>
				<td class="text-center">{{ item.manager_ids.length | number }}</td>
				<td class="text-center">{{ item.user_ids.length | number }}</td>
				<td class="text-center">{{ item.accessTags.length | number }}</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
						{{ item.added_on | timeback }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>